import axios from "axios";
import { Urls } from "../../../store/urls";

// Polls Filter Repo
export const getPollsFilterRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_POllS_FILTER_API,
        params: params,
    });
};
// Poll's List Repo
export const getPollsListRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_POllS_LIST_API,
        params: params,
    });
};

// Polls Detail Repo
export const getPollsRepo= (params) =>{
    return axios({
        method: "GET",
        url: Urls.POLLS_API,
        params:params,
    });
};

// Add Poll Repo
export const postPollsRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.POLLS_API,
        data: data,
    });
};
// Update Poll Repo
export const putPollsRepo = (data) => {
    return axios({
        method: "PUT",
        url: Urls.POLLS_API,
        data: data,
    });
};

// Delete Poll Repo
export const deletePollsRepo = (data) => {
    return axios({
        method: "DELETE",
        url: Urls.POLLS_API,
        params: data,
    });
};

// Get comment moderation Filter
export const getCommentModerationFilterRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_COMMENT_MODERATION_FILTER_API,
        params: params,
    });
};
// Get comment moderation listing
export const getCommentModerationListRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_COMMENT_MODERATION_LIST_API,
        params: params,
    });
};
//Get comment Moderation Edit
export const getCommentModerationEditRepo = (id, params) => {
    return axios({
        method: "GET",
        url: Urls.GET_COMMENT_MODERATION_LIST_API + '/' + id,
        params: params,
    });
};

//put comment moderation
export const putCommentModerationSubmitRepo = (id, data) => {
    return axios({
        method: "PUT",
        url: Urls.GET_COMMENT_MODERATION_LIST_API + '/' + id,
        data: data,
    });
};


